import { render, staticRenderFns } from "./HTMLTable.vue?vue&type=template&id=2daa765e&"
import script from "./HTMLTable.vue?vue&type=script&lang=js&"
export * from "./HTMLTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports